<app-loading *ngIf="isLoading"></app-loading>

<div *ngIf="selected else listBlock">
  <mat-toolbar color="primary" class="mat-elevation-z6">
    <button mat-icon-button (click)="selected = null">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span i18n>RESULT PARAMETERS</span>
  </mat-toolbar>
  <app-result-download-form [element]="selected"></app-result-download-form>
</div>

<ng-template #listBlock>

  <mat-selection-list [multiple]="false">
    <mat-list-option *ngFor="let item of list$ | async" (click)="select(item)">
      <div mat-line>
        {{item.description}}
      </div>
      <div mat-line>
        {{item.status_description}}
      </div>
    </mat-list-option>
  </mat-selection-list>
  <div class="app-button-actions">
    <button mat-raised-button (click)="load()" i18n>UPDATE STATUS</button>
  </div>

</ng-template>
